<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

	{{ value }}

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

    data: function() {

		return {
			value: ''
		}

	},

	watch: {

		item: {
			handler: function() {

				this.updateVars()

			},
			deep: true
		}

	},

	created: function() {

		this.updateVars()

	},

	methods: {

		updateVars: function() {

			var value = (this.isUser) ? this.item.user.duration : this.item.users.totalDuration

			if (value > 0) {

				this.value = Math.ceil(value / 60)

			} else {

				this.value = 0

			}

		}

	}

}

</script>

<style scoped>

</style>